
























import Vue from 'vue'
import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import { Injector } from '@/config/dependency-injection'
import { HomeModule } from '@/business/home/store/home-module'
import UnifyHero from '@/shared/components/unify/unify-hero.vue'
import { BlogPost } from '@/api/generated'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { FETCH_UPDATES } from '@/business/home/store/types'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'

@Component({
  name: 'UpdatesPage',
  components: { RespondecoLoadingIndicator, UnifyHero },
})
export default class UpdatesPage extends Vue implements Hooks {
  private readonly homeModule = Injector.get(HomeModule)
  private readonly loaderHelper = Injector.get(LoaderHelper)

  public get updates(): BlogPost[] {
    return this.homeModule.updates.items
  }

  public get loading(): boolean {
    return this.loaderHelper.isLoading(FETCH_UPDATES)
  }

  public mounted() {
    this.homeModule.fetchUpdates()
  }
}
